import React from "react";
import { SectionTitleComponent } from "../../../components/section-title.component";
import { ServiceComponent } from "./service.component";
import { data } from "../../../data";

interface IServiceContainerComponentProps {}

export const ServiceContainerComponent: React.FC<
    IServiceContainerComponentProps
> = (props: IServiceContainerComponentProps) => {
    const section = {
        title: "Services",
        subTitle:
            "We provide expert guidance and support for obtaining and maintaining essential licenses, including Factory Licenses, Labour Licenses, BOCW registrations, MPCB permits, PSARA Licenses, Shop Act registrations, and Professional Tax compliance, as well as navigating all applicable Labor Laws. Your success is our mission.",
        services: [
            {
                delay: 100,
                icon: "cash-stack",
                // subTitle: (
                //     <>
                //         This is a unique service based on advanced, specially
                //         designed software that manages the entire payroll of
                //         your company. We meet the statutory requirements of
                //         various government Acts and Notifications issued from
                //         time to time. This service effectively and efficiently
                //         manages the entire back-office and PAYROLL operations,
                //         which helps your organization concentrate on your core
                //         business operations.
                //     </>
                // ),
                subTitle:
                    "This is a unique service based on advanced, specially designed software that manages the entire payroll of your company. We meet the statutory requirements of various government Acts and Notifications issued from time to time. This service effectively and efficiently manages the entire back-office and PAYROLL operations, which helps your organization concentrate on your core business operations",
                title: "Payroll Management Service",
                path: "/payroll-management-service",
            },
            {
                delay: 200,
                icon: "file-earmark-text",
                // subTitle: <PayrollComplianceComponent />,
                subTitle:
                    "We provide comprehensive payroll compliance services, ensuring your business adheres to all relevant labor laws and regulations. Our expertise covers a wide range of requirements, from accurate tax filings and statutory deductions to timely report submissions and audits. We stay up-to-date with the latest regulatory changes, minimizing your risk of non-compliance and allowing you to focus on your strategic objectives. Our meticulous approach and in-depth knowledge guarantee that your payroll processes are always accurate, compliant, and efficient.",
                title: "Payroll Compliance",
                path: data.routes.payrollCompliance,
            },
            {
                delay: 300,
                icon: "bank",
                // subTitle: (
                //     <>
                //         As per the "Employees' Provident Funds and Miscellaneous
                //         Provisions Act, 1952" and subsequent notifications, the
                //         Act applies to all factories and establishments that
                //         employ twenty or more workmen. We offer services for the
                //         registration of companies with the EPF Department,
                //         including new employee registration, monthly compliance
                //         towards the submission of Form 2, Form 5, Form 9, and
                //         monthly EPF Challans and Returns. We make payments to
                //         the concerned department and complete the required
                //         formalities in a timely manner before the scheduled due
                //         dates. We undertake the generation of UANs for all
                //         registered employees and assist in the refund and
                //         settlement of claims within the shortest possible time.
                //     </>
                // ),
                subTitle:
                    'As per the "Employees Provident Funds and Miscellaneous Provisions Act, 1952" and subsequent notifications, the Act applies to all factories and establishments that employ twenty or more workmen. We offer services for the registration of companies with the EPF Department, including new employee registration, monthly compliance towards the submission of Form 2, Form 5, Form 9, and monthly EPF Challans and Returns. We make payments to the concerned department and complete the required formalities in a timely manner before the scheduled due dates. We undertake the generation of UANs for all registered employees and assist in the refund and settlement of claims within the shortest possible time.',
                title: "EPF - Employees Provident Fund",
                path: data.routes.epf,
            },
            {
                delay: 400,
                icon: "shield",
                // subTitle: (
                //     <>
                //         The Employees' State Insurance Act, 1948 (ESI Act)
                //         scheme is applicable to all factories and establishments
                //         as defined in the Act, with 10 or more persons employed
                //         in such establishments, and where the beneficiaries'
                //         monthly wages do not exceed Rs. 21,000. We offer
                //         services for the registration of companies with the ESI
                //         Department, including new employee registration and
                //         monthly compliance, such as monthly ESIC summary and
                //         challan generation. We make payments to the concerned
                //         department and complete the required formalities in a
                //         timely manner before the scheduled due dates. We
                //         undertake the generation of ESI numbers for all
                //         registered employees and assist in the refund and
                //         settlement of claims.
                //     </>
                // ),
                subTitle:
                    "The Employees' State Insurance Act, 1948 (ESI Act) scheme is applicable to all factories and establishments as defined in the Act, with 10 or more persons employed in such establishments, and where the beneficiaries' monthly wages do not exceed Rs. 21,000. We offer services for the registration of companies with the ESI Department, including new employee registration and monthly compliance, such as monthly ESIC summary and challan generation. We make payments to the concerned department and complete the required formalities in a timely manner before the scheduled due dates. We undertake the generation of ESI numbers for all registered employees and assist in the refund and settlement of claims.",
                title: "ESIC - Employee State Insurance Corporation Act",
                path: data.routes.esic,
            },
            {
                delay: 500,
                icon: "person-arms-up",
                // subTitle: (
                //     <>
                //         The Act is applicable to all factories and other
                //         establishments employing 10 or more workmen in
                //         Maharashtra. We undertake the registration and statutory
                //         compliance with the Maharashtra Labour Welfare Board
                //         (MLWB) Department on a half-yearly basis in a timely
                //         manner.
                //     </>
                // ),
                subTitle:
                    "The Act is applicable to all factories and other establishments employing 10 or more workmen in Maharashtra. We undertake the registration and statutory compliance with the Maharashtra Labour Welfare Board (MLWB) Department on a half-yearly basis in a timely manner.",
                title: "MLWB - Maharashtra Labour Welfare Board Act",
                path: data.routes.mlwb,
            },
            {
                delay: 600,
                icon: "activity",
                // subTitle: (
                //     <>
                //         Various states across India levy professional tax as per
                //         the prescribed state rules. We undertake the
                //         registration with the Professional Tax Department and
                //         meet the monthly, half-yearly, and yearly requirements.
                //     </>
                // ),
                subTitle:
                    "Various states across India levy professional tax as per the prescribed state rules. We undertake the registration with the Professional Tax Department and meet the monthly, half-yearly, and yearly requirements.",
                title: "Professional Tax",
                path: data.routes.professionalTax,
            },
            {
                delay: 700,
                icon: "file-medical",
                // subTitle: (
                //     <>
                //         The Act is applicable to all factories and other
                //         establishments employing 10 or more workmen. Gratuity is
                //         a lump sum amount that employers pay their employees as
                //         an expression of gratitude for the services provided.
                //         The Gratuity Act, 1972. We undertake the registration
                //         and statutory compliance on a monthly basis in a timely
                //         manner.
                //     </>
                // ),
                subTitle:
                    "The Act is applicable to all factories and other establishments employing 10 or more workmen. Gratuity is a lump sum amount that employers pay their employees as an expression of gratitude for the services provided. The Gratuity Act, 1972. We undertake the registration and statutory compliance on a monthly basis in a timely manner.",
                title: "Payment of Gratuity",
                path: data.routes.paymentOfGratuty,
            },
            {
                delay: 800,
                icon: "currency-rupee",
                // subTitle: (
                //     <>
                //         As per the Bonus Act, 1965, applicable to all factories
                //         and every other establishment that employs twenty or
                //         more workmen, we undertake the registration and
                //         statutory compliance in a timely manner.
                //     </>
                // ),
                subTitle:
                    "As per the Bonus Act, 1965, applicable to all factories and every other establishment that employs twenty or more workmen, we undertake the registration and statutory compliance in a timely manner.",
                title: "Payment of Bonus",
                path: data.routes.paymentOfBonus,
            },
            {
                delay: 900,
                icon: "easel",
                // subTitle: (
                //     <>
                //         <p>
                //             We assist in undertaking registration and
                //             certification with various government departments:
                //         </p>
                //         <RegCertComponent />
                //         <p>
                //             Our expertise in registration and certification
                //             helps you in the completion of the above-mentioned
                //             registrations in a timely manner.
                //         </p>
                //     </>
                // ),
                subTitle:
                    "We streamline the complex processes of business registration and certification, ensuring your company meets all necessary legal and regulatory requirements. Our comprehensive services cover a wide array of registrations, including PSARA, Trademark, EPF, ESIC, MLWB, PTAX, GST, and more. We handle every step, from initial applications to final approvals, saving you time and resources. Our in-depth knowledge of local and national regulations guarantees a smooth and efficient process, enabling you to focus on growing your business with confidence.",
                title: "Registration & Certification",
                path: data.routes.regAndCertification,
            },
            {
                delay: 1000,
                icon: "search-heart",
                // subTitle: (
                //     <>
                //         <p>
                //             We assist in undertaking registration and
                //             certification with various government departments:
                //         </p>
                //         <RegCertComponent />
                //         <p>
                //             Our expertise in registration and certification
                //             helps you in the completion of the above-mentioned
                //             registrations in a timely manner.
                //         </p>
                //     </>
                // ),
                subTitle:
                    "In today's competitive and regulated business landscape, particularly in a thriving hub like Pune, Maharashtra, ensuring the integrity and reliability of your workforce is paramount. Our comprehensive background verification services provide thorough due diligence, encompassing a range of critical checks. From meticulous Gap Checks to identify employment discrepancies, to rigorous Employment Verification and Education Verification to confirm credentials, we leave no stone unturned. We also conduct stringent Government ID Verification to authenticate identity, perform FIR Check / Police Verification for criminal history, and verify Address Checks to establish residency. Additionally, our Court Verification and Reference Checks offer insights into an individual's legal standing and professional conduct. These services are essential for mitigating risks, fostering a secure work environment, and maintaining compliance with local regulations, ultimately contributing to the success and reputation of your organization in Pune and beyond.",
                title: "Background Verification",
                path: data.routes.bgv,
            },
        ],
    };
    return (
        <section id="services" className="services section text-justify">
            <SectionTitleComponent
                title={section.title}
                subTitle={section.subTitle}
            />

            <div className="container">
                <div className="row gy-4">
                    {data.services?.map((service: any, index: number) => {
                        return (
                            <ServiceComponent
                                delay={200 * (index + 1)}
                                key={service.title}
                                {...service}
                            />
                        );
                    })}
                </div>
            </div>
        </section>
    );
};
